export default class BackgroundThemeImageMultipleList {
    fieldsIds = []
    items = []

    add(backgroundThemeImageMultiple) {
      backgroundThemeImageMultiple.order = this.items.length
      this.items.push(backgroundThemeImageMultiple)
    }

    addFieldId(id) {
      if (this.fieldsIds.includes(id)) return
      this.fieldsIds.push(id);
    }

    getItemById(id) {
      return this.items.find((item) => item.id === id)
    }

    getIndexById(id) {
        return this.items.findIndex((item) => item.id === id)
    }

    getItemsByTemplateFieldId(fieldId) {
      return this.items.filter(
        item => item.templateField.getId() === fieldId
      )
    }

    getInputDatasByTemplateFieldId(fieldId) {
      return this.items.map(item => {
        if (item.templateField.getId() === fieldId) {
          return item.inputData
        }
      }).filter(Boolean)
    }

    getInputDatasToJson(fieldId) {
      return JSON.stringify(this.getInputDatasByTemplateFieldId(fieldId))
    }

    getAllInputDatasToJson() {
      return this.fieldsIds.map((fieldId) => {
        return this.getInputDatasToJson(fieldId)
      })
    }

    update(id, data) {
      const item = this.getItemById(id)
      if (!item) return

      item.inputData.setData(data)
    }

    resetCoordinate(fieldId) {
      this.items.forEach(item => {
        if (item.templateField.getId() !== fieldId) return

        this.update(item.id, {
          ...item.inputData,
          x: null,
          y: null,
          bounding_x: null,
          bounding_y: null
        })
        
        item.update()
      })
    }

    remove(id, canvas) {
      const item = this.getItemById(id)
      if (!item) return
      item.removeObjects(canvas)

      this.items = this.items.filter(item => item.getId() !== id)
    }

    removeByFieldId(id, canvas) {
      this.items = this.items.filter(item => {
        if (item.templateField.getId() === id) {
          item.removeObjects(canvas)
        } else {
          return item 
        }
      })
    }

    removeAll(canvas) {
      this.fieldsIds.forEach(fieldId => {
        this.removeByFieldId(fieldId, canvas)
      })
    }

    render(canvas, isRenderAll = true) {
      const promise = []
      this.items.forEach(async item => {
        if (item.object && !isRenderAll) return

        item.removeObjects(canvas)
        
        promise.push(item.render())
      })

      return Promise.all(promise).then(res => {
        res.forEach(item => {
          canvas.add(item)
        })
      })
    }
}